import React, { useState } from 'react';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AssignmentType } from '../../../../../api/types/settings/studies/assignment-type';
import dateUtils from '../../../../../utils/date-format';
import { Button } from 'primereact/button';
import { AddNewAssignmentTypeDialog } from './components/add-new-assignment-type-dialog';
import { Dialog } from 'primereact/dialog';
import { deleteAssignmentOperation } from './operations/delete-assignment-operation';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { observer } from 'mobx-react-lite';

export const SettingsEducationAssignmentsTab = observer(() => {
  const [addNewAssignmentType, setAddNewAssignmentType] = useState(false);
  const [editAssignment, setEditAssignment] = useState<AssignmentType | null>(
    null,
  );
  const [loading, setLoading] = useState(false);
  const [selectedAssignments, setSelectedAssignments] = useState<
    AssignmentType[]
  >([]);

  const [deleteAssignmentId, setDeleteAssignmentId] = useState<number | null>(
    null,
  );

  const handleDeleteProgram = async (assignmentId: number) => {
    await deleteAssignmentOperation(assignmentId, setDeleteAssignmentId);
  };

  const handleEditAssignment = (assignment: AssignmentType) => {
    setEditAssignment(assignment);
  };

  const handleSaveAssignment = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.ASSIGNMENT_TYPE,
      id,
      newName,
      setLoading,
    );
  };

  return (
    <div>
      <Dialog
        header="הוספת סוג מטלה"
        visible={addNewAssignmentType}
        onHide={() => setAddNewAssignmentType(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddNewAssignmentTypeDialog
          onHide={() => setAddNewAssignmentType(false)}
        />
      </Dialog>

      <EditTextDialog
        id={editAssignment?.id}
        value={editAssignment?.assignmentTypeName}
        title="עריכת סוג מטלה"
        label="שם סוג המטלה"
        loading={loading}
        onSave={handleSaveAssignment}
        onHide={() => setEditAssignment(null)}
      />

      <Button
        onClick={() => setAddNewAssignmentType(true)}
        style={{ height: '30px' }}
        label={'הוספה'}
      />
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedAssignments}
        onSelectionChange={(e) => setSelectedAssignments(e.value)}
        value={globalSettingsStores.assignmentTypes}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="assignmentTypeName"
          header="שם"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          body={(rowData: AssignmentType) => (
            <div>{dateUtils.displayFormatDate(rowData.createdAt)}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: AssignmentType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סוג מטלה'}
                onClick={() => handleEditAssignment(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סוג מטלה'}
                loading={deleteAssignmentId === data.id}
                disabled={deleteAssignmentId !== null}
                onClick={() => handleDeleteProgram(data.id)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
